import React from "react";

const SegmentedControl = ({
    options = [],
    value,
    onChange,
    name,
    disabled = false,
}) => {
    return (
        <div
            style={{
                display: "flex",
                border: "1px solid #0c3529",
                borderRadius: "8px",
                overflow: "hidden",
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? "none" : "auto",
            }}
        >
            {options.map((opt, index) => {
                const isActive = value === opt.value;

                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => onChange(opt.value)}
                        style={{
                            flex: 1,
                            padding: "4px 8px",
                            border: "none",
                            backgroundColor: isActive ? "#0c3529" : "white",
                            color: isActive ? "white" : "#0c3529",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            borderRight:
                                index !== options.length - 1
                                    ? "1px solid #0c3529"
                                    : "none",
                            textWrap: "nowrap",
                        }}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
};

export default SegmentedControl;
